import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SHOPIFY_URL } from '../constants';
type Props = {
  children?: React.ReactNode;
  size?: 'md' | 'lg';
  pulse?: boolean;
  trustLine?: string | null;
  className?: string;
  fullWidth?: boolean;
};
export const CTAButton: React.FC<Props> = ({
  children = 'Obtener el libro ahora',
  size = 'md',
  pulse = false,
  trustLine = 'Acceso instantáneo · PDF · Pago seguro vía Shopify',
  className = '',
  fullWidth = false
}) => {
  const padding = size === 'lg' ? 'px-10 py-5 text-base' : 'px-8 py-4 text-sm';
  return <div className={`flex flex-col items-center gap-3 ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`} data-id="element-41">
      <a href={SHOPIFY_URL} className={`btn-gold ${pulse ? 'cta-pulse' : ''} ${padding} rounded-full inline-flex items-center justify-center gap-2.5 group tracking-wide w-full sm:w-auto ${fullWidth ? '!w-full' : ''}`} data-id="element-42">
        <span data-id="element-43">{children}</span>
        <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-500" strokeWidth={2} data-id="element-44" />
      </a>
      {trustLine && <p className={`text-[11px] text-ivory/45 tracking-[0.15em] uppercase ${fullWidth ? 'text-center w-full' : ''}`} data-id="element-45">
          {trustLine}
        </p>}
    </div>;
};